import {
  getMoneylineHttpWrapper,
  postMoneylineHttpWrapper,
  parseMoneylineStatusResponse,
  parseMoneylineConfigurationResponse,
} from './moneyline.utils';
import {
  Status,
  MoneylineStatusResponse,
  Configuration,
  MoneylineConfigurationResponse,
  MoneylineTicketPayload,
  MoneylineSuccessResponse,
} from './moneyline.types';

export const getStatus = async (): Promise<Status> => {
  const rawStatus = await getMoneylineHttpWrapper<MoneylineStatusResponse>(
    `${process.env.REACT_APP_MONEYLINE_LOCAL_API}/Management/GetStatus`,
  );
  return parseMoneylineStatusResponse(rawStatus);
};

export const getConfiguration = async (): Promise<Configuration> => {
  const rawConfig = await getMoneylineHttpWrapper<
    MoneylineConfigurationResponse
  >(`${process.env.REACT_APP_MONEYLINE_LOCAL_API}/Management/GetConfiguration`);
  return parseMoneylineConfigurationResponse(rawConfig);
};

export const isPaymentTerminalEnabled = (
  status: Status,
  currentParameters: Configuration,
): boolean => {
  return (
    process.env.NODE_ENV === 'development' ||
    (status.CB === true && currentParameters.CB === true)
  );
};

export const isConecsEnabled = (
  totalPrice: number,
  currentState: Status,
  currentParameters: Configuration,
): boolean => {
  return (
    isPaymentTerminalEnabled(currentState, currentParameters) &&
    currentParameters.ConecsMaxAmount !== undefined &&
    currentParameters.ConecsMaxAmount > 0 &&
    currentParameters.CONECS === true &&
    totalPrice <= currentParameters.ConecsMaxAmount
  );
};

export const printTicket = (
  serializedTicketArray: MoneylineTicketPayload | undefined,
): Promise<MoneylineSuccessResponse<unknown>> => {
  return postMoneylineHttpWrapper(
    `${process.env.REACT_APP_MONEYLINE_LOCAL_API}/Print/PrintModel`,
    {
      PrintingModel: 'Ticket',
      ...serializedTicketArray,
    },
  );
};

export const startPaymentCB = (
  orderId: string,
  amount: number,
): Promise<MoneylineSuccessResponse<{
  ID: string;
  AmountPaid: number;
  Ticket: string;
}>> => {
  return postMoneylineHttpWrapper(
    `${process.env.REACT_APP_MONEYLINE_LOCAL_API}/Payment/StartPaymentCB`,
    {
      ID: orderId,
      Amount: amount,
    },
  );
};

export const startPaymentConecs = (
  orderId: string,
  amount: number,
): Promise<MoneylineSuccessResponse<unknown>> => {
  return postMoneylineHttpWrapper(
    `${process.env.REACT_APP_MONEYLINE_LOCAL_API}/Payment/StartPaymentConecs`,
    {
      ID: orderId,
      Amount: amount,
    },
  );
};

export const startTransaction = (): Promise<MoneylineSuccessResponse<
  unknown
>> => {
  return postMoneylineHttpWrapper(
    `${process.env.REACT_APP_MONEYLINE_LOCAL_API}/Transaction/StartTransaction`,
    {},
  );
};

export const stopTransaction = (): Promise<MoneylineSuccessResponse<
  unknown
>> => {
  return postMoneylineHttpWrapper(
    `${process.env.REACT_APP_MONEYLINE_LOCAL_API}/Transaction/StopTransaction`,
    {},
  );
};

export const startReadContactless = (): Promise<MoneylineSuccessResponse<{
  ReadValue: string;
}>> => {
  return postMoneylineHttpWrapper(
    `${process.env.REACT_APP_MONEYLINE_LOCAL_API}/Transaction/ReadContactless`,
    {},
  );
};

export const stopReadContactless = (): Promise<MoneylineSuccessResponse<
  unknown
>> => {
  return postMoneylineHttpWrapper(
    `${process.env.REACT_APP_MONEYLINE_LOCAL_API}/Transaction/StopReadContactless`,
    {},
  );
};
